import React from 'react';
import { createPortal } from 'react-dom';

interface LoadingOverlayProps {
  loading: boolean;
  title?: string;
  message?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  loading,
  title = 'Cargando...',
  message = 'Por favor espera...',
}) => {
  if (!loading) return null;

  return createPortal(
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full mx-4">
        <div className="flex items-center justify-center mb-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500"></div>
        </div>
        <h3 className="text-lg font-semibold text-center text-gray-900 mb-2">{title}</h3>
        <p className="text-sm text-gray-600 text-center">{message}</p>
      </div>
    </div>,
    document.body
  );
};
